import { EmailFastIcon } from './EmailFastIcon';

/**
 * author: Colton Wiscombe
 * id 3BDD7A0B-DA90-459E-8219-58EDC08661FE
 * name email-fast
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-fast.svg
 * tags
 */
export const EnvelopeFastIcon = EmailFastIcon;
export default EnvelopeFastIcon